/* unplugin-vue-components disabled */import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "device-alarm-detail device-alarm-add-rule"
};
var _hoisted_2 = {
  class: "device-alarm-info"
};
var _hoisted_3 = {
  key: 0,
  class: "van-cell van-field"
};
var _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "van-cell__title van-field__label"
}, "告警时长", -1);
var _hoisted_5 = {
  class: "van-cell__value van-field__value"
};
var _hoisted_6 = {
  key: 0,
  class: "warn-time"
};
var _hoisted_7 = {
  class: "van-cell van-field"
};
var _hoisted_8 = {
  class: "van-cell__title van-field__label"
};
var _hoisted_9 = {
  class: "van-cell__value van-field__value"
};
var _hoisted_10 = {
  class: "device-alarm-add-rule-sub"
};
import { getDeviceUsers, postAddWarnRule, getWarningDisposeList, getWarningRuleList, editWarningRule } from '@/service/deviceAlarm/index';
// import ContentPage from '@/components/ContentPage/index.vue';
import { showToast } from 'vant';
// import './index.less';
import './common.less';
import './addAlarmRule.less';
// interface CheckedType {}
export default /*#__PURE__*/_defineComponent({
  __name: 'AddAlarmRule',
  setup: function setup(__props) {
    var warnTypeList = [{
      text: '告警',
      warnType: 1
    }, {
      text: '指派',
      warnType: 2
    }];
    var router = useRouter();
    // const route = useRoute();
    var warnTypeOption = reactive({
      warnType: 1,
      label: ''
    });
    var warnShowPicker = ref(false);
    var userCheckbox = reactive({
      showCheckbox: false,
      checked: [],
      list: []
    });
    var btnLoading = ref(false);
    var warnAssignTimeOption = reactive({
      type: [{
        value: '1',
        label: '秒'
      }, {
        value: '2',
        label: '分钟'
      }, {
        value: '3',
        label: '小时'
      }
      // { value: '4', label: '天' }
      ],
      value: '',
      num: undefined,
      show: false
    });
    var userClose = function userClose(index) {
      var checked = _toConsumableArray(userCheckbox.checked);
      checked.splice(index, 1);
      userCheckbox.checked = checked;
    };
    var onWarnConfirm = function onWarnConfirm(value) {
      warnTypeOption.label = value.text;
      warnTypeOption.warnType = value.warnType;
      warnShowPicker.value = false;
      if (warnTypeOption.warnType == 1) {
        _getWarningRuleList();
      } else if (warnTypeOption.warnType == 2) {
        _getWarningDisposeList();
      }
    };
    var getUnit = function getUnit(value) {
      var unit = warnAssignTimeOption.type.find(function (item) {
        return item.value === value;
      });
      return (unit === null || unit === void 0 ? void 0 : unit.label) || '';
    };
    var onSubmit = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var sendData, users, res, message, timer;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              sendData = {};
              users = userCheckbox.checked.map(function (item) {
                return {
                  id: item.uid,
                  name: item.userName
                };
              });
              if (warnTypeOption.warnType) {
                _context.next = 5;
                break;
              }
              showToast('请选择告警设置');
              return _context.abrupt("return");
            case 5:
              if (!(users.length == 0)) {
                _context.next = 8;
                break;
              }
              showToast('请选择提醒人');
              return _context.abrupt("return");
            case 8:
              if (!(warnTypeOption.warnType == 2 && !warnAssignTimeOption.value)) {
                _context.next = 11;
                break;
              }
              showToast('请选择时长单位');
              return _context.abrupt("return");
            case 11:
              if (!(warnTypeOption.warnType == 2 && !warnAssignTimeOption.num)) {
                _context.next = 14;
                break;
              }
              showToast('请输入告警时长');
              return _context.abrupt("return");
            case 14:
              if (warnTypeOption.warnType === 1) {
                sendData = {
                  warnType: warnTypeOption.warnType,
                  users: users
                };
                if (ruleList.length > 0) {
                  sendData['id'] = ruledetail.id;
                }
              } else {
                sendData = {
                  warnType: warnTypeOption.warnType,
                  users: users,
                  warnAssignTime: warnAssignTimeOption.num,
                  warnTimeUnit: Number(warnAssignTimeOption.value)
                };
                if (ruleList.length > 0) {
                  sendData['id'] = disposeDetail.id;
                }
              }
              _context.prev = 15;
              btnLoading.value = true;
              res = {};
              message = '';
              if (!sendData.id) {
                _context.next = 26;
                break;
              }
              message = '修改';
              _context.next = 23;
              return editWarningRule(sendData.id, sendData);
            case 23:
              res = _context.sent;
              _context.next = 30;
              break;
            case 26:
              message = '新增';
              _context.next = 29;
              return postAddWarnRule(sendData);
            case 29:
              res = _context.sent;
            case 30:
              if (res.status == '1') {
                showToast.success("".concat(message, "\u6210\u529F"));
              } else {
                showToast("".concat(message, "\u5931\u8D25"));
              }
              timer = setTimeout(function () {
                clearTimeout(timer);
                btnLoading.value = false;
                router.back();
              }, 500);
              _context.next = 37;
              break;
            case 34:
              _context.prev = 34;
              _context.t0 = _context["catch"](15);
              btnLoading.value = false;
            case 37:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[15, 34]]);
      }));
      return function onSubmit() {
        return _ref.apply(this, arguments);
      };
    }();
    var ruleList = [];
    var ruledetail = {};
    var _getWarningRuleList = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _resData$data, resData;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              showToast.loading({
                message: '加载中...',
                forbidClick: true,
                duration: 0
              });
              _context2.prev = 1;
              _context2.next = 4;
              return getWarningRuleList({
                pageIndex: 1,
                pageSize: 10
              });
            case 4:
              resData = _context2.sent;
              ruleList = (resData === null || resData === void 0 || (_resData$data = resData.data) === null || _resData$data === void 0 ? void 0 : _resData$data.records) || [];
              if (ruleList.length > 0) {
                ruledetail = ruleList[0];
                warnTypeOption.label = '告警';
                warnTypeOption.warnType = 1;
                userCheckbox.checked = [];
                ruledetail.eaDeviceWarnRuleAssigns.map(function (item) {
                  userCheckbox.list.map(function (info) {
                    if (item.userId == info.uid) {
                      userCheckbox.checked.push(info);
                    }
                  });
                });
                console.log(warnTypeOption, userCheckbox);
              }
              showToast.clear();
              _context2.next = 14;
              break;
            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](1);
              console.log(_context2.t0);
              showToast.clear();
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[1, 10]]);
      }));
      return function _getWarningRuleList() {
        return _ref2.apply(this, arguments);
      };
    }();
    var disposeList = [];
    var disposeDetail = {};
    var _getWarningDisposeList = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _resData$data2, resData;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              showToast.loading({
                message: '加载中...',
                forbidClick: true,
                duration: 0
              });
              _context3.prev = 1;
              _context3.next = 4;
              return getWarningDisposeList({
                pageIndex: 1,
                pageSize: 10
              });
            case 4:
              resData = _context3.sent;
              disposeList = (resData === null || resData === void 0 || (_resData$data2 = resData.data) === null || _resData$data2 === void 0 ? void 0 : _resData$data2.records) || [];
              if (disposeList.length > 0) {
                disposeDetail = disposeList[0];
                warnTypeOption.label = '指派';
                warnTypeOption.warnType = 2;
                warnAssignTimeOption.value = "".concat(disposeDetail.warnTimeUnit);
                warnAssignTimeOption.num = disposeDetail.warnAssignTime;
                userCheckbox.checked = [];
                disposeDetail.eaDeviceWarnRuleAssigns.map(function (item) {
                  userCheckbox.list.map(function (info) {
                    if (item.userId == info.uid) {
                      userCheckbox.checked.push(info);
                    }
                  });
                });
              }
              showToast.clear();
              _context3.next = 14;
              break;
            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](1);
              showToast.clear();
              console.log(_context3.t0);
            case 14:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[1, 10]]);
      }));
      return function _getWarningDisposeList() {
        return _ref3.apply(this, arguments);
      };
    }();
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var _userRes$data;
      var userRes;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return getDeviceUsers();
          case 2:
            userRes = _context4.sent;
            userCheckbox.list = (userRes === null || userRes === void 0 || (_userRes$data = userRes.data) === null || _userRes$data === void 0 ? void 0 : _userRes$data.list) || [];
            _getWarningRuleList();
          case 5:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    })));
    return function (_ctx, _cache) {
      var _component_van_field = _resolveComponent("van-field");
      var _component_van_picker = _resolveComponent("van-picker");
      var _component_van_popup = _resolveComponent("van-popup");
      var _component_van_radio = _resolveComponent("van-radio");
      var _component_van_radio_group = _resolveComponent("van-radio-group");
      var _component_van_tag = _resolveComponent("van-tag");
      var _component_van_checkbox = _resolveComponent("van-checkbox");
      var _component_van_cell = _resolveComponent("van-cell");
      var _component_van_cell_group = _resolveComponent("van-cell-group");
      var _component_van_checkbox_group = _resolveComponent("van-checkbox-group");
      var _component_van_form = _resolveComponent("van-form");
      var _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_form, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_cell_group, {
            inset: ""
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_van_field, {
                modelValue: _unref(warnTypeOption).label,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                  return _unref(warnTypeOption).label = $event;
                }),
                "is-link": "",
                readonly: "",
                name: "picker",
                label: "告警设置",
                placeholder: "请选择",
                onClick: _cache[1] || (_cache[1] = function ($event) {
                  return warnShowPicker.value = true;
                })
              }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
                show: _unref(warnShowPicker),
                "onUpdate:show": _cache[3] || (_cache[3] = function ($event) {
                  return _isRef(warnShowPicker) ? warnShowPicker.value = $event : null;
                }),
                position: "bottom"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_van_picker, {
                    columns: warnTypeList,
                    onConfirm: onWarnConfirm,
                    onCancel: _cache[2] || (_cache[2] = function ($event) {
                      return warnShowPicker.value = false;
                    })
                  })];
                }),
                _: 1
              }, 8, ["show"]), _unref(warnTypeOption).warnType == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
                class: "van-field__body",
                placeholder: "请选择",
                onClick: _cache[4] || (_cache[4] = function ($event) {
                  return _unref(warnAssignTimeOption).show = true;
                })
              }, [_unref(warnAssignTimeOption).num && _unref(warnAssignTimeOption).value ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(warnAssignTimeOption).num) + " " + _toDisplayString(getUnit(_unref(warnAssignTimeOption).value)), 1)) : _createCommentVNode("", true)])]), _createElementVNode("i", {
                class: "van-badge__wrapper van-icon van-icon-arrow van-cell__right-icon",
                onClick: _cache[5] || (_cache[5] = function ($event) {
                  return _unref(warnAssignTimeOption).show = true;
                })
              })])) : _createCommentVNode("", true), _createVNode(_component_van_popup, {
                show: _unref(warnAssignTimeOption).show,
                "onUpdate:show": _cache[8] || (_cache[8] = function ($event) {
                  return _unref(warnAssignTimeOption).show = $event;
                }),
                round: "",
                position: "bottom",
                class: "van-popup-plate"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_van_radio_group, {
                    modelValue: _unref(warnAssignTimeOption).value,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
                      return _unref(warnAssignTimeOption).value = $event;
                    }),
                    direction: "horizontal"
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_van_field, {
                        name: "radio",
                        label: "单位"
                      }, {
                        input: _withCtx(function () {
                          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(warnAssignTimeOption).type, function (item, index) {
                            return _openBlock(), _createBlock(_component_van_radio, {
                              name: item.value,
                              key: index,
                              "icon-size": "20"
                            }, {
                              default: _withCtx(function () {
                                return [_createTextVNode(_toDisplayString(item.label), 1)];
                              }),
                              _: 2
                            }, 1032, ["name"]);
                          }), 128))];
                        }),
                        _: 1
                      }), _createVNode(_component_van_field, {
                        modelValue: _unref(warnAssignTimeOption).num,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
                          return _unref(warnAssignTimeOption).num = $event;
                        }),
                        type: "digit",
                        label: "数值",
                        placeholder: "请输入"
                      }, null, 8, ["modelValue"])];
                    }),
                    _: 1
                  }, 8, ["modelValue"])];
                }),
                _: 1
              }, 8, ["show"]), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(_unref(warnTypeOption).warnType == 1 ? '提醒人' : '指派人'), 1), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
                class: "van-field__body",
                placeholder: "请选择",
                onClick: _cache[9] || (_cache[9] = function ($event) {
                  return _unref(userCheckbox).showCheckbox = true;
                })
              }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userCheckbox).checked, function (item, index) {
                return _openBlock(), _createBlock(_component_van_tag, {
                  type: "primary",
                  class: "user-tag",
                  contenteditable: false,
                  closeable: "",
                  onClose: function onClose() {
                    return userClose(index);
                  },
                  key: item.uid,
                  plain: ""
                }, {
                  default: _withCtx(function () {
                    return [_createTextVNode(_toDisplayString(item.userName), 1)];
                  }),
                  _: 2
                }, 1032, ["onClose"]);
              }), 128))])]), _createElementVNode("i", {
                class: "van-badge__wrapper van-icon van-icon-arrow van-cell__right-icon",
                onClick: _cache[10] || (_cache[10] = function ($event) {
                  return _unref(userCheckbox).showCheckbox = true;
                })
              })]), _createVNode(_component_van_popup, {
                show: _unref(userCheckbox).showCheckbox,
                "onUpdate:show": _cache[12] || (_cache[12] = function ($event) {
                  return _unref(userCheckbox).showCheckbox = $event;
                }),
                round: "",
                position: "bottom",
                class: "van-popup-plate"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_van_checkbox_group, {
                    modelValue: _unref(userCheckbox).checked,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = function ($event) {
                      return _unref(userCheckbox).checked = $event;
                    })
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_van_cell_group, {
                        inset: ""
                      }, {
                        default: _withCtx(function () {
                          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userCheckbox).list, function (item) {
                            return _openBlock(), _createBlock(_component_van_cell, {
                              clickable: "",
                              key: item.uid,
                              title: item.userName
                            }, {
                              "right-icon": _withCtx(function () {
                                return [_createVNode(_component_van_checkbox, {
                                  name: item,
                                  "icon-size": "20"
                                }, null, 8, ["name"])];
                              }),
                              _: 2
                            }, 1032, ["title"]);
                          }), 128))];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  }, 8, ["modelValue"])];
                }),
                _: 1
              }, 8, ["show"])];
            }),
            _: 1
          })];
        }),
        _: 1
      })]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_van_button, {
        round: "",
        block: "",
        type: "primary",
        onClick: onSubmit,
        loading: _unref(btnLoading)
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(" 确定 ")];
        }),
        _: 1
      }, 8, ["loading"])])]);
    };
  }
});